import Vue from 'vue';
import Multiselect from "vue-multiselect";
import MakeYourBookings from './make-your-bookings/MakeYourBookings.vue'

Vue.component('make-your-bookings', MakeYourBookings)
Vue.component('multiselect', Multiselect)



// WEBPACK FOOTER //
// ./src/components/components.js